<div class="business-summary-page" style="overflow-x: hidden; scrollbar-width: none;">
  <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

  <!-- Modern Filter Bar Card -->
  <form #df="ngForm" novalidate (keydown.enter)="onSearchBusinessData()" class="filter-card">
    <div class="row align-items-end">
      <!-- From Date -->
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
        <label class="filter-label">From Date</label>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="FromDate" id="FromDate"
            #refFromDate="ngModel" class="form-control input-text-css" (dateChange)="DateChange()" required
            [(ngModel)]="FromDate" [ngClass]="{
              'is-invalid': df.submitted && refFromDate.invalid,
              'alert-warning':
                refFromDate.invalid &&
                (refFromDate.dirty ||
                  refFromDate.touched ||
                  refFromDate.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <!-- To Date -->
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
        <label class="filter-label">To Date</label>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="ToDate" id="ToDate"
            #refToDate="ngModel" class="form-control input-text-css" (dateChange)="DateChange()" required
            [(ngModel)]="ToDate" [ngClass]="{
              'is-invalid': df.submitted && refToDate.invalid,
              'alert-warning':
                refToDate.invalid &&
                (refToDate.dirty || refToDate.touched || refToDate.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>

      <!-- Report Type -->
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-2">
        <label class="filter-label">Report Type</label>
        <select name="ReportType" id="ReportType" [(ngModel)]="ReportType" class="form-control input-text-css"
          (change)="onChangeReportTypes()" required #refReportType="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refReportType.invalid,
            'alert-warning':
              refReportType.invalid &&
              (refReportType.dirty ||
                refReportType.touched ||
                refReportType.untouched)
          }">
          <option value="">Select Report Type</option>
          <option *ngFor="let row of ArrTypes" [value]="row.id">
            {{ row.value }}
          </option>
        </select>
      </div>

      <!-- Slab Dropdown (if active) -->
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2" *ngIf="SlabDropdown">
        <label class="filter-label">Slab Name</label>
        <select name="SlabId" id="SlabId" [(ngModel)]="SlabId" class="form-control input-text-css" required
          #refSlabId="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refSlabId.invalid,
            'alert-warning':
              refSlabId.invalid &&
              (refSlabId.dirty || refSlabId.touched || refSlabId.untouched)
          }">
          <option value="''">Select Slab Name</option>
          <option *ngFor="let row of SlabData" [value]="row.Id">
            {{ row.Slab_name }}
          </option>
        </select>
      </div>

      <!-- With Zero Balance Checkbox -->
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2 d-flex align-items-center" style="height: 2.375rem;">
        <label class="custom-control custom-checkbox m-0 d-flex align-items-center" style="cursor: pointer;">
          <input type="checkbox" class="custom-control-input" name="WithZeroBalance" id="WithZeroBalance" [(ngModel)]="WithZeroBalance">
          <span class="custom-control-label font-weight-600 font-size-12 text-dark">With Zero Balance</span>
        </label>
      </div>

      <!-- Search Button -->
      <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2">
        <button type="button" (click)="onSearchBusinessData()" class="btn font-size-12 button-btn btn-block"
          [disabled]="!df.form.valid">
          <i class="fas fa-search mr-1"></i> Search
        </button>
      </div>
    </div>
  </form>

  <!-- Executive KPI Metrics Ribbon (When data exists) -->
  <div class="kpi-ribbon-row row mt-3" *ngIf="dataSourceTree">
    <!-- Card 1: Total No. Of Loans -->
    <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
      <div class="kpi-stat-card border-accent-blue">
        <div class="kpi-card-header">
          <span class="kpi-label">Total Loans</span>
          <div class="kpi-icon-badge bg-blue-subtle text-primary">
            <i class="fas fa-file-invoice"></i>
          </div>
        </div>
        <div class="kpi-value">{{ Math.round(totaltypewiseBranch1('NoOfLoans')) | number:'1.0-0' }}</div>
        <div class="kpi-footer-sub">Total Disbursed Units</div>
      </div>
    </div>

    <!-- Card 2: Total Business -->
    <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
      <div class="kpi-stat-card border-accent-green">
        <div class="kpi-card-header">
          <span class="kpi-label">Total Business</span>
          <div class="kpi-icon-badge bg-green-subtle text-success">
            <i class="fas fa-rupee-sign"></i>
          </div>
        </div>
        <div class="kpi-value text-success" [title]="formatCurrency(totaltypewiseBranch1('TotalBusiness'))">
          {{ formatCompactCurrency(totaltypewiseBranch1('TotalBusiness')) }}
        </div>
        <div class="kpi-footer-sub" [title]="formatCurrency(totaltypewiseBranch1('TotalBusiness'))">
          {{ formatCurrency(totaltypewiseBranch1('TotalBusiness')) }}
        </div>
      </div>
    </div>

    <!-- Card 3: Avg Loan Size -->
    <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
      <div class="kpi-stat-card border-accent-indigo">
        <div class="kpi-card-header">
          <span class="kpi-label">Avg Loan Size</span>
          <div class="kpi-icon-badge bg-indigo-subtle text-info">
            <i class="fas fa-calculator"></i>
          </div>
        </div>
        <div class="kpi-value text-dark" [title]="formatCurrency(totaltypewiseBranch1('NoOfLoans') > 0 ? (totaltypewiseBranch1('TotalBusiness') / totaltypewiseBranch1('NoOfLoans')) : 0)">
          {{ formatCompactCurrency(totaltypewiseBranch1('NoOfLoans') > 0 ? (totaltypewiseBranch1('TotalBusiness') / totaltypewiseBranch1('NoOfLoans')) : 0) }}
        </div>
        <div class="kpi-footer-sub">
          {{ formatCurrency(totaltypewiseBranch1('NoOfLoans') > 0 ? (totaltypewiseBranch1('TotalBusiness') / totaltypewiseBranch1('NoOfLoans')) : 0) }}
        </div>
      </div>
    </div>

    <!-- Card 4: IN Percentage -->
    <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
      <div class="kpi-stat-card border-accent-amber">
        <div class="kpi-card-header">
          <span class="kpi-label">Portfolio Share</span>
          <div class="kpi-icon-badge bg-amber-subtle text-warning">
            <i class="fas fa-chart-pie"></i>
          </div>
        </div>
        <div class="kpi-value text-dark">{{ Math.round(totaltypewiseBranch1('IN_Percentage')) }}%</div>
        <div class="kpi-footer-sub">Cumulative Share</div>
      </div>
    </div>

    <!-- Card 5: Avg LTV -->
    <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
      <div class="kpi-stat-card border-accent-teal">
        <div class="kpi-card-header">
          <span class="kpi-label">Avg LTV</span>
          <div class="kpi-icon-badge bg-teal-subtle text-teal">
            <i class="fas fa-shield-alt"></i>
          </div>
        </div>
        <div class="kpi-value text-dark">
          {{ totaltypewiseBranch1("NoOfLoans") > 0 ? (parentSummary?.TotalLTV_AVG / totaltypewiseBranch1("NoOfLoans") | number:'1.2-2') : '0.00' }}%
        </div>
        <div class="kpi-footer-sub">Loan-to-Value Ratio</div>
      </div>
    </div>

    <!-- Card 6: Avg Tenure -->
    <div class="col-xl-2 col-md-4 col-sm-6 mb-3">
      <div class="kpi-stat-card border-accent-purple">
        <div class="kpi-card-header">
          <span class="kpi-label">Avg Tenure</span>
          <div class="kpi-icon-badge bg-purple-subtle text-purple">
            <i class="fas fa-calendar-alt"></i>
          </div>
        </div>
        <div class="kpi-value text-dark">
          {{ totaltypewiseBranch1("NoOfLoans") > 0 ? (parentSummary?.TotalTenure_AVG / totaltypewiseBranch1("NoOfLoans") | number:'1.2-2') : '0.00' }}
          <span class="font-size-12 font-weight-normal text-muted">Mo</span>
        </div>
        <div class="kpi-footer-sub">Average Repayment Duration</div>
      </div>
    </div>
  </div>

  <!-- Main Content Row: Table & Insights Side Panel -->
  <div class="row mt-2" *ngIf="dataSourceTree">
    <!-- Left: Branch / Product Tree Table -->
    <div class="col-lg-8 col-xl-8 mb-3">
      <div class="dashboard-table-card">
        <!-- Table Toolbar -->
        <div class="table-card-toolbar d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="fas fa-code-branch text-primary mr-2" style="font-size: 1.1rem;"></i>
            <h6 class="m-0 font-weight-bold text-dark">
              {{ ReportType == '3' ? 'Product Wise Business Summary' : 'Branch Wise Business Summary' }}
            </h6>
          </div>
          <div class="d-flex align-items-center">
            <button class="btn btn-sm font-size-12 button-btn" (click)="exportTreeTable()" title="Export data to Excel">
              <i class="fas fa-file-excel mr-1"></i> Export to Excel
            </button>
          </div>
        </div>

        <!-- Table Container -->
        <div class="table-responsive tree-table-responsive">
          <table mat-table [dataSource]="dataSourceTree" class="mat-elevation-z0 modern-data-table" matSort matTableExporter
            #exporter="matTableExporter">
            <!-- Product Column -->
            <ng-container matColumnDef="Product_Name">
              <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Product</th>
              <td mat-cell *matCellDef="let data">
                <span class="branch-pill-link" (click)="productwiseDashboard(data); selectedProductRow = data;"
                  [class.active]="selectedProductRow === data">
                  <i class="fas fa-cube mr-1"></i> {{ data.Product_Name }}
                </span>
              </td>
              <th mat-footer-cell *matFooterCellDef class="font-weight-bold">Total</th>
            </ng-container>

            <!-- Branch Column -->
            <ng-container matColumnDef="Branch_Name">
              <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Branch</th>
              <td mat-cell *matCellDef="let data">
                <span class="branch-pill-link" matRipple (click)="branchwiseDashboard(data); selectedBranchRow = data"
                  [class.active]="selectedBranchRow === data">
                  <i class="fas fa-building mr-1"></i> {{ data.Branch_Name }}
                </span>
              </td>
              <th mat-footer-cell *matFooterCellDef class="font-weight-bold">Total</th>
            </ng-container>

            <!-- No of Loans Column -->
            <ng-container matColumnDef="NoOfLoans">
              <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Loans</th>
              <td mat-cell *matCellDef="let data" class="text-right font-weight-600 text-dark">
                {{ data.NoOfLoans | number:'1.0-0' }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right font-weight-bold">
                {{ Math.round(totaltypewiseBranch1("NoOfLoans")) | number:'1.0-0' }}
              </th>
            </ng-container>

            <!-- Avg LTV Column -->
            <ng-container matColumnDef="Avg_LTV">
              <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Avg LTV</th>
              <td mat-cell *matCellDef="let data" class="text-right">
                {{ data.Avg_LTV ? (data.Avg_LTV | number:'1.2-2') + '%' : '-' }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right font-weight-bold">
                {{ totaltypewiseBranch1("NoOfLoans") > 0 ? Math.round(totaltypewiseBranch1("Avg_LTV")/totaltypewiseBranch1("NoOfLoans")) + '%' : '0%' }}
              </th>
            </ng-container>

            <!-- Avg Tenure Column -->
            <ng-container matColumnDef="Avg_Tenure">
              <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Tenure</th>
              <td mat-cell *matCellDef="let data" class="text-right">
                {{ data.Avg_Tenure ? (data.Avg_Tenure | number:'1.1-1') + 'm' : '-' }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right font-weight-bold">
                {{ totaltypewiseBranch1("NoOfLoans") > 0 ? Math.round(totaltypewiseBranch1("Avg_Tenure")/totaltypewiseBranch1("NoOfLoans")) + 'm' : '0m' }}
              </th>
            </ng-container>

            <!-- Total Business Column -->
            <ng-container matColumnDef="TotalBusiness">
              <th mat-header-cell mat-sort-header class="text-right font-weight-bold" *matHeaderCellDef>Total Business</th>
              <td mat-cell *matCellDef="let row" class="text-right font-weight-600 text-success">
                ₹{{ row.TotalBusiness | number:'1.0-0' }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right font-weight-bold text-success">
                ₹{{ Math.round(totaltypewiseBranch1("TotalBusiness")) | number:'1.0-0' }}
              </th>
            </ng-container>

            <!-- Avg Loan Size Column -->
            <ng-container matColumnDef="AvgLoanSize">
              <th mat-header-cell mat-sort-header class="text-right font-weight-bold" *matHeaderCellDef>Avg Size</th>
              <td mat-cell *matCellDef="let row" class="text-right">
                ₹{{ (row.TotalBusiness / row.NoOfLoans) | number:'1.0-0' }}
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right font-weight-bold">
                ₹{{ totaltypewiseBranch1("NoOfLoans") > 0 ? (totaltypewiseBranch1("TotalBusiness") / totaltypewiseBranch1("NoOfLoans") | number:'1.0-0') : '0' }}
              </th>
            </ng-container>

            <!-- Share Column -->
            <ng-container matColumnDef="IN_Percentage">
              <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Share</th>
              <td mat-cell *matCellDef="let data" class="text-right">
                <span class="badge badge-light-blue">{{ data.IN_Percentage }}%</span>
              </td>
              <th mat-footer-cell *matFooterCellDef class="text-right font-weight-bold">
                {{ Math.round(totaltypewiseBranch1("IN_Percentage")) }}%
              </th>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold" style="width: 50px;">Action</th>
              <td mat-cell *matCellDef="let row" class="text-center">
                <button class="btn btn-sm btn-outline-primary action-icon-btn" (click)="goToBookingListDetails(row)"
                  *ngIf="row.NoOfLoans > 0" title="View Booking Details">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedTreeColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; let i = index; columns: displayedTreeColumns"
              class="table-data-row"
              [class.active-selected-row]="selectedBranchRow === row || selectedProductRow === row"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedTreeColumns; sticky: true" class="table-footer-row"></tr>
          </table>
        </div>
      </div>
    </div>

    <!-- Right: Insights & Gender Breakdown Card -->
    <div class="col-lg-4 col-xl-4 mb-3">
      <div class="insights-side-card">
        <div class="insights-card-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i class="fas fa-chart-bar text-primary mr-2"></i>
            <h6 class="m-0 font-weight-bold text-dark">
              {{ selectedBranchRow?.Branch_Name || selectedProductRow?.Product_Name || 'Branch Insights' }}
            </h6>
          </div>
          <span class="badge badge-primary font-weight-600" *ngIf="selectedBranchRow || selectedProductRow">Active</span>
        </div>

        <div class="insights-card-body">
          <!-- Gender Breakdown if present -->
          <div class="gender-section" *ngIf="genderItem.length >= 1; else selectBranchGuide">
            <div class="text-center mb-2 font-weight-700 text-muted font-size-11 text-uppercase letter-spacing-1">
              Gender Demographics
            </div>

            <!-- Donut + Legends -->
            <div class="donut-and-legends">
              <div class="chart-wrapper">
                <svg viewBox="0 0 140 140" preserveAspectRatio="xMidYMid meet">
                  <circle cx="70" cy="70" r="60" stroke="#e2e8f0" stroke-width="12" fill="none" />
                  <circle cx="70" cy="70" r="60" stroke="url(#femaleGradient)" stroke-width="12" fill="none"
                    [attr.stroke-dasharray]="getFemaleArc() + ',377'" stroke-linecap="round"
                    transform="rotate(-90 70 70)" />
                  <circle cx="70" cy="70" r="60" stroke="url(#maleGradient)" stroke-width="12" fill="none"
                    [attr.stroke-dasharray]="getMaleArc() + ',377'" stroke-linecap="round"
                    [attr.transform]="'rotate(' + (-90 + getFemaleArc()) + ' 70 70)'" />

                  <defs>
                    <linearGradient id="femaleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stop-color="#ec4899" />
                      <stop offset="100%" stop-color="#f472b6" />
                    </linearGradient>
                    <linearGradient id="maleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stop-color="#0284c7" />
                      <stop offset="100%" stop-color="#38bdf8" />
                    </linearGradient>
                  </defs>
                </svg>
                <div class="center-text">
                  <span class="big font-weight-bold">{{ Total_Loan | number:'1.0-0' }}</span>
                  <span class="small text-muted font-size-11">Total Loans</span>
                </div>
              </div>

              <!-- Gender Stats Mini Cards -->
              <div class="gender-mini-cards mt-3">
                <div class="mini-gender-card male-card mb-2">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="gender-pill male-pill"><i class="fas fa-male mr-1"></i> Male</span>
                    <span class="font-weight-bold text-dark">{{ malePercentage | number:'1.1-1' }}%</span>
                  </div>
                  <div class="d-flex justify-content-between font-size-12 text-muted">
                    <span>Loans: <b class="text-dark">{{ maleLoans | number:'1.0-0' }}</b></span>
                    <span>Amount: <b class="text-dark">₹{{ maleBusiness | number:'1.0-0' }}</b></span>
                  </div>
                </div>

                <div class="mini-gender-card female-card">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="gender-pill female-pill"><i class="fas fa-female mr-1"></i> Female</span>
                    <span class="font-weight-bold text-dark">{{ femalePercentage | number:'1.1-1' }}%</span>
                  </div>
                  <div class="d-flex justify-content-between font-size-12 text-muted">
                    <span>Loans: <b class="text-dark">{{ femaleLoans | number:'1.0-0' }}</b></span>
                    <span>Amount: <b class="text-dark">₹{{ femaleBusiness | number:'1.0-0' }}</b></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-template #selectBranchGuide>
            <div class="text-center py-4 px-3 text-muted">
              <div class="empty-icon-circle mx-auto mb-3">
                <i class="fas fa-mouse-pointer text-primary"></i>
              </div>
              <h6 class="font-weight-600 text-dark mb-1">Interactive Branch Analytics</h6>
              <p class="font-size-12 mb-0">Click on any Branch or Product in the table to view its demographic breakdown, marital status, and sales executive details.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Lower Drilldown Tables (When branch or product is clicked) -->
  <div class="row mt-3 align-items-start" *ngIf="maritalStatusItem.length >= 1 || productItem.length > 0 || branchItem.length > 0 || salesExecItem.length >= 1">
    <!-- Marital Status -->
    <div class="col-xl-4 col-md-6 mb-3" *ngIf="maritalStatusItem.length >= 1">
      <div class="detail-table-card">
        <div class="detail-card-header">Marital Status Distribution</div>
        <div class="table-responsive">
          <table class="table modern-detail-table mb-0">
            <thead>
              <tr>
                <th>Marital Status</th>
                <th class="text-right">Loans</th>
                <th class="text-right">Total Business</th>
                <th class="text-right">Share %</th>
                <th class="text-right">Avg Size</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of maritalStatusItem">
                <td class="font-weight-500">{{ row.Customer_MaritalStatus || '-' }}</td>
                <td class="text-right font-weight-600">{{ row.Total_Loan | number:'1.0-0' }}</td>
                <td class="text-right font-weight-600 text-primary">₹{{ row.Total_Business | number:'1.0-0' }}</td>
                <td class="text-right">{{ row.IN_Percentage }}%</td>
                <td class="text-right">₹{{ (row.Total_Business / row.Total_Loan) | number:'1.0-0' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Product Wise Details -->
    <div class="col-xl-4 col-md-6 mb-3" *ngIf="productItem.length > 0">
      <div class="detail-table-card">
        <div class="detail-card-header">Product Wise Details</div>
        <div class="table-responsive">
          <table class="table modern-detail-table mb-0">
            <thead>
              <tr>
                <th>Product Name</th>
                <th class="text-right">Loans</th>
                <th class="text-right">Total Business</th>
                <th class="text-right">Share %</th>
                <th class="text-right">Avg Size</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of productItem">
                <td class="font-weight-500">{{ row.Product_Name || '-' }}</td>
                <td class="text-right font-weight-600">{{ row.Total_Loan | number:'1.0-0' }}</td>
                <td class="text-right font-weight-600 text-primary">₹{{ row.Total_Business | number:'1.0-0' }}</td>
                <td class="text-right">{{ row.IN_Percentage }}%</td>
                <td class="text-right">₹{{ (row.Total_Business / row.Total_Loan) | number:'1.0-0' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Branch Wise Details -->
    <div class="col-xl-4 col-md-6 mb-3" *ngIf="branchItem.length > 0">
      <div class="detail-table-card">
        <div class="detail-card-header">Branch Wise Details</div>
        <div class="table-responsive">
          <table class="table modern-detail-table mb-0">
            <thead>
              <tr>
                <th>Branch Name</th>
                <th class="text-right">Loans</th>
                <th class="text-right">Total Business</th>
                <th class="text-right">Share %</th>
                <th class="text-right">Avg Size</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of branchItem">
                <td class="font-weight-500">{{ row.Branch_Name || '-' }}</td>
                <td class="text-right font-weight-600">{{ row.Total_Loan | number:'1.0-0' }}</td>
                <td class="text-right font-weight-600 text-primary">₹{{ row.Total_Business | number:'1.0-0' }}</td>
                <td class="text-right">{{ row.IN_Percentage }}%</td>
                <td class="text-right">₹{{ (row.Total_Business / row.Total_Loan) | number:'1.0-0' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Sales Executive Details -->
    <div class="col-xl-4 col-md-6 mb-3" *ngIf="salesExecItem.length >= 1">
      <div class="detail-table-card">
        <div class="detail-card-header">Sales Executive Performance</div>
        <div class="table-responsive">
          <table class="table modern-detail-table mb-0">
            <thead>
              <tr>
                <th>Sales Executive Name</th>
                <th class="text-right">Loans</th>
                <th class="text-right">Total Business</th>
                <th class="text-right">Share %</th>
                <th class="text-right">Avg Size</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of salesExecItem">
                <td class="font-weight-500">
                  <span *ngIf="row.Sales_Executive_Name && row.Sales_Executive_Name.trim()">
                    {{ row.Sales_Executive_Name }}
                  </span>
                  <span *ngIf="!row.Sales_Executive_Name || !row.Sales_Executive_Name.trim()" class="text-muted font-italic">
                    Direct / Unassigned
                  </span>
                </td>
                <td class="text-right font-weight-600">{{ row.Total_Loan | number:'1.0-0' }}</td>
                <td class="text-right font-weight-600 text-primary">₹{{ row.Total_Business | number:'1.0-0' }}</td>
                <td class="text-right">{{ row.IN_Percentage }}%</td>
                <td class="text-right">₹{{ (row.Total_Business / row.Total_Loan) | number:'1.0-0' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3 tableGraph" *ngIf="DataDiv && !dataSourceTree">
    <div class="col-md-6 tableHeight">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource" matSort matTableExporter #exporter="matTableExporter">
          <ng-container matColumnDef="Id">
            <mat-header-cell mat-sort-header class="grid-header mw5" *matHeaderCellDef>#</mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw5">
              {{ i + 1 }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="width: 3.5625rem"></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Branch_Name">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Branch Name</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Branch_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Gender">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Gender</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Gender }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Religion">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Religion</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Religion }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Cast">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Caste</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Cast }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="MaritalStatus">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Marital Status</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.MaritalStatus }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Customer_Profile">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Profile</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Customer_Profile }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Natureofwork">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Nature of work
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Natureofwork }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Loan_Acc_Category">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Loan A\c Category</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Loan_Acc_Category }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="Product_Name">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Product Name</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Product_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="SlabName">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Slab Name</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.SlabName }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="Employee_Name">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Sales Executive</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Employee_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="NoOfLoans">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>No. Of
              Loans</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.NoOfLoans }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ dataSource ? totaltypewise("NoOfLoans") : "" }}
            </mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TotalBusiness">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>Total
              Business</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.TotalBusiness }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ dataSource ? totaltypewise("TotalBusiness") : "" }}
            </mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="AvgLoanSize">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>Avg Loan
              Size</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ (row.TotalBusiness /
              row.NoOfLoans).toFixed(2) }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{
              dataSource
              ? (
              totaltypewise("TotalBusiness") /
              totaltypewise("NoOfLoans")
              ).toFixed(2)
              : ""
              }}
            </mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="IN_Percentage">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>IN
              Percentage</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.IN_Percentage }}%</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ dataSource ? totaltypewise("IN_Percentage") : "" }}
            </mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell text-center">
              <i class="fa fa-arrow-circle-right arrow-circle action-btn" (click)="goToBookingListDetails(row)"
                *ngIf="row.NoOfLoans > 0" aria-label="true"></i>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 100%"></mat-footer-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <mat-footer-row class="sticky-footer fontcolor" *matFooterRowDef="displayedColumns"></mat-footer-row>
        </mat-table>
        <div class="row m-0 align-items-center" style="background: #fff">
          <div class="col-md-12 p-2">
            <button class="mt-3 btn font-size-12 button-btn" (click)="exportNormalTable()">
              <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5 formborder d-flex justify-content-center align-items-center" *ngIf="chartdata">
      <app-charts [chartdata]="chartdata" [Types]="Types"></app-charts>
    </div>
  </div>
</div>

<div class="modal fade in" id="ViewBookingListDetails" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          View Details
        </h6>
        <button type="button" (click)="onCloseDueListDetails()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <mat-table [dataSource]="DataSourceModel" matSort matTableExporter #exporter="matTableExporter"
            style="height: 25rem; max-width: 100%; overflow: auto">
            <ng-container [matColumnDef]="col" *ngFor="let col of displayedColumnsModel">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                {{ columnDisplayNames[col] || col }}

              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <div *ngIf="col == 'Id'">
                  {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
                </div>
                <div *ngIf="
                    currentUser.IsMaskingMobile && col == 'Customer_PhoneNo'
                  ">
                  {{ row[col] | mask }}
                </div>
                <div *ngIf="
                    !currentUser.IsMaskingMobile && col == 'Customer_PhoneNo'
                  ">
                  {{ row[col] }}
                </div>
                <div *ngIf="col != 'Customer_PhoneNo'">{{ row[col] }}</div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumnsModel; sticky: true"></mat-header-row>
            <mat-row (click)="highlightRow(row)" [class.highlight]="row.Loan_Id == selectedId"
              *matRowDef="let row; columns: displayedColumnsModel"></mat-row>
          </mat-table>

          <div class="row m-0 align-items-center d-flex justify-content-between align-items-center">
            <div class="col-md-2">
              <button class="mt-3 btn font-size-12 button-btn" (click)="exportTableforbookinglist()">
                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                Export
              </button>
            </div>

            <div class="col-md-4 mt-1">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch" placeholder="What're you searching for?"
                      class="form-control border-0 bg-light" />
                    <div class="input-group-append">
                      <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-6">
              <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<table id="businesswise_model" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th *ngFor="let col of displayedColumnsModel" style="background: var(--theme-primary) !important; border: 1px solid white">
      {{ col == "Id" ? "#" : col.split("_").join(" ") }}
    </th>
  </tr>
  <tr *ngFor="let row of FileCheckingList; let i = index" [ngClass]="row.level === 0 ? 'export-highlight' : ''">
    <td *ngFor="let col of displayedColumnsModel">
      <ng-container *ngIf="col === 'Product_Name' || col === 'Branch_Name'">
        {{ removePrefix(row[col]) }}
      </ng-container>
      <ng-container *ngIf="col !== 'Product_Name' && col !== 'Branch_Name'">
        {{
        col == "Id"
        ? paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1)
        : row[col]
        }}
      </ng-container>
    </td>
  </tr>
</table>